
import { Flex } from "@chakra-ui/react";
import ParallaxText from "../components/ParallaxText";

/**
 * The Parallax Text Component
 * @returns The Parallax Text Component
 */
export default function ParallaxTextSection() {

    return (
        <Flex
            flexDirection={"column"}
            width={"100%"}
            justifyContent={"center"}
            alignItems={"center"}
            marginBottom={"40px"}
        >
            <ParallaxText
                text="John Bajor"
                direction="left"
                speed={50}
            />
            <ParallaxText
                text="UI/UX Designer"
                direction="right"
                speed={65}
            />
            <ParallaxText
                text="Freelancer"
                direction="left"
                speed={35}
            />
            <ParallaxText
                text="Open to Work"
                direction="right"
                speed={43}
            />
        </Flex>
    );
}
